/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { DeleteConnectionMutationResponse, DeleteConnectionPathParams } from "../models/DeleteConnection";

export function getDeleteConnectionUrl(station: DeleteConnectionPathParams["station"], platform: DeleteConnectionPathParams["platform"]) {
  const res = { method: 'DELETE', url: `/connections/${station}/${platform}` as const }
  return res
}

/**
 * @summary Delete station connection
 * {@link /connections/:station/:platform}
 */
export async function deleteConnection(station: DeleteConnectionPathParams["station"], platform: DeleteConnectionPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteConnectionMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getDeleteConnectionUrl(station, platform).url.toString(), ... requestConfig })
  return res.data
}